import React from 'react'
import { Loader, animationFadeIn, createAnimationDelay, makeStyles } from '@cicero/ui'
import { PageDoc } from '../../models'
import { PageCard } from '../PageCard'

/**
 * Show a list of pages as cards
 */
export const CardLayout = ({ pages, isLoading }: { pages: PageDoc[], isLoading?: boolean }) => {
  const { cards, block } = useStyles()

  return (
    <ul className={cards}>
      { pages.map((page, i) => (<li key={i} className={block}><PageCard page={page} header preview /></li>)) }
      { isLoading ? <Loader /> : null }
    </ul>
  )
}

const useStyles = makeStyles({
  cards: {
    background: '#EEE',
    boxSizing: 'border-box',
    columnCount: 10,
    columnFill: 'auto',
    columnGap: '8px',
    margin: 0,
    padding: 8,
    width: '100%',
    '@media screen and (max-width: 2100px)': {
      columnCount: 8,
    },
    '@media screen and (max-width: 1900px)': {
      columnCount: 6,
    },
    '@media screen and (max-width: 1700px)': {
      columnCount: 5,
    },
    '@media screen and (max-width: 1500px)': {
      columnCount: 4,
    },
    '@media screen and (max-width: 1300px)': {
      columnCount: 3,
    },
    '@media screen and (max-width: 1100px)': {
      columnCount: 2,
    },
    '@media screen and (max-width: 800px)': {
      columnCount: 1,
    },
  },
  block: {
    animation: '$FadeIn ease-out .5s',
    columnBreakInside: 'avoid',
    display: 'block',
    margin: '0 auto',
    maxWidth: 400,
    padding: '6px',
    wordWrapBreak: 'word',
    ...createAnimationDelay(50, 0.01),
  },
  ...animationFadeIn,
})
